import { useContext, useEffect, useState } from 'react'
import Typography from '@mui/material/Typography'
import { motion } from 'framer-motion'
import { FeatureDict, selectFeatureIncludes } from '@authed/selectors'
import { useAppSelector } from '@redux/hooks'
import { api } from 'api'
import { integrationContext } from '../contexts'
import { IntegrationCard } from './integrations/IntegrationCard'
import { t } from '@lingui/core/macro'

export const Integrations = ({ match }) => {
  const [assignedIntegrations, setAssignedIntegrations] = useState([])
  const { fetchIntegrations } = useContext(integrationContext)
  const [DATASETS_ENABLED = false] = useAppSelector(
    selectFeatureIncludes([FeatureDict.DATASETS_PAGE]),
  )
  const templateId = match.params.id

  useEffect(() => {
    api.get(`/api/v1/account/template/${templateId}`).then(({ data }) => {
      setAssignedIntegrations(data.integrations)
    })
  }, [])

  useEffect(() => {
    fetchIntegrations()
  }, [])

  const entity = DATASETS_ENABLED ? 'dataset' : 'template'

  return (
    <motion.div
      className="admin"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.15 } }}
      exit={{ opacity: 0, transition: { duration: 0.15 } }}
      style={{
        padding: 30,
        height: '100%',
        overflow: 'hidden',
      }}
    >
      <Typography variant="h2">{t`Installed integrations`}</Typography>
      <Typography variant="body2" gutterBottom>
        {t`These are the integrations that are currently assigned to run on your ${entity}`}
      </Typography>
      <div style={{ marginTop: 24 }}>
        {assignedIntegrations.map(assignedIntegration => {
          return (
            <IntegrationCard
              key={assignedIntegration.id}
              integrationAssignment={assignedIntegration}
            />
          )
        })}
      </div>
    </motion.div>
  )
}
